import type { FC } from 'react';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DAProtectIconWithTooltip from '@wix/da-shared-react/pkg/DAProtectIconWithTooltip';
import { getCurrentUserHasCore } from '@wix/da-shared-react/pkg/publicSession/selectors';
import SharedFolderDropdown, {
  Props as FolderDropdownProps,
} from '@wix/da-shared-react/pkg/GallectionFolderDropdown';
import { isCurrentUserProfileOwner } from '../../../../../../selectors/users';
import { useNonEmptyGallectionFolders } from '../../../hooks/useGallectionFolders';
import { setSelectedFolderId } from '../../../../../../actions/gallectionSection';
import GalleryUpsellCard from '../../../GalleryUpsellCard';
import { useGalleryUpsell } from '../../../hooks/useGalleryUpsell';

import s from './FolderBarFolderDropdown.scss';

export interface Props extends Omit<
  FolderDropdownProps,
  | 'id'
  | 'folders'
  | 'hasMore'
  | 'fetchMore'
  | 'hasLess'
  | 'fetchLess'
  | 'isLoading'
  | 'setSelectedFolderId'
  | 'isCurrentUserProfileOwner'
> {}

const FolderBarFolderDropdown: FC<Props> = props => {
  const dispatch = useDispatch();
  const { folders, hasMore, isFetching, fetchNext, hasLess, fetchPrevious } =
    useNonEmptyGallectionFolders();
  const handleSetSelectedFolderId = useCallback(
    number => {
      if (window) {
        window.scrollTo(0, 0);
      }
      dispatch(setSelectedFolderId(number));
    },
    [dispatch]
  );

  const hasCore = useSelector(getCurrentUserHasCore);
  const isOwner = useSelector(isCurrentUserProfileOwner);
  const { showPromo, promoType, promoDeviation, promoCount } = useGalleryUpsell();

  return (
    <SharedFolderDropdown
      {...props}
      id={'folders-dropdown'}
      folders={folders}
      hasMore={hasMore}
      isLoading={isFetching}
      fetchMore={fetchNext}
      hasLess={hasLess}
      fetchLess={fetchPrevious}
      setSelectedFolderId={handleSetSelectedFolderId}
      showCurrentFolderTotal
      isCurrentUserProfileOwner={isOwner}
      folderNamePostfixIcon={
        isOwner &&
        hasCore && <DAProtectIconWithTooltip variant="active" className={s['da-protect-icon']} />
      }
      modalFooter={
        showPromo ? (
          <GalleryUpsellCard
            promoType={promoType}
            promoCount={promoCount}
            promoDeviation={promoDeviation}
          />
        ) : undefined
      }
    />
  );
};
FolderBarFolderDropdown.displayName = 'FolderBarFolderDropdown';

export default FolderBarFolderDropdown;
